<template>
    <div class="waitlist">
        <Heading :h="2" size="s" weight="regular">
            {{ content.areYouReady }}
        </Heading>
        <Heading :h="2" size="xl">
            {{ content.forAnEpicJourney }}
        </Heading>
        <Button class="joinButton"
            size="fullWidth"
            @click="$emit('openWaitlistModal')">
            {{ content.joinTheWaitlist }}
        </Button>
    </div>
</template>

<script>
    export default {
        name: 'Waitlist',
        props: {
            content: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">

    .waitlist {
        max-width: 32rem;
    }

    .h2 {
        text-align: center;
        margin: 0 0 1rem 0;

        &:last-of-type {
            margin-bottom: 3rem;
        }
    }

    .joinButton {
        margin-bottom: 8rem;
    }
</style>